
import { useState } from "react";
import { Card } from "@material-ui/core";
import MessageError from "../../../../messages/messageError";
import api from "../../../../services/api";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import ButtonLeft from "../../../../utils/buttonLeft";


export default function CreateObservacaoFarmacovigilancia({ farmacoVigilanciaId, userId, setUpdate }) {
    const [messageError, setMessageError] = useState('')
    const [observacao, setObservacao] = useState('')
    const [load, setLoad] = useState(false)

    const sendObservacao = async () => {
        setUpdate(false)
        setLoad(true)
        setMessageError('')

        await api.patch('/farmaco-vigilancia/add-observacao', { farmacoVigilanciaId, userId, 'content': observacao })
            .then(response => {
                setLoad(false)
                setUpdate(true)
                clearInput()

            }).catch(error => {
                console.log(error)
                setLoad(false)
                setMessageError(error.response.data.message)
            })
    }

    const clearInput = () => {
        document.getElementById('inputObs').value = '';
        setObservacao('')
    }

    return (
        <Card style={{ padding: 20, position: 'relative', marginTop: 10 }}>
            {messageError && <MessageError message={messageError} />}

            {/* <br /> */}
            <FazerObservacoes
                observacao={observacao}
                setObs={setObservacao}
                // obs={obs}
                titulo="(Caso precise descreve aquí qualquer observação sobre esta notificação.)"
            />

            <ButtonLeft
                title={'Salvar'}
                disabled={!observacao || load}
                funcao={sendObservacao}
                load={load}
            />
        </Card>
    )
}